import { Button } from '@/components/shadcn/button';
import { SuggestionSchema } from '@/utils/llm-schema';

export type SuggestionClick = (s: string) => void;

function Suggestion({
  dir,
  title,
  onSuggestionClick,
}: SuggestionSchema & { onSuggestionClick?: SuggestionClick }) {
  return (
    <Button
      className="h-fit"
      disabled={!onSuggestionClick}
      onClick={() => onSuggestionClick?.(title)}
      dir={dir}
    >
      <p className="text-wrap">{title}</p>
    </Button>
  );
}

export function MessageSuggestionList({
  suggestionList,
  onSuggestionClick,
}: {
  suggestionList: SuggestionSchema[];
  onSuggestionClick?: SuggestionClick;
}) {
  if (suggestionList?.length) {
    return (
      <div className="max-w-md flex flex-wrap gap-2 p-4">
        {suggestionList.map((e) => (
          <Suggestion key={e.title} {...e} onSuggestionClick={onSuggestionClick} />
        ))}
      </div>
    );
  }
  return null;
}
